export default __webpack_public_path__ + "static/media/user.240888ac.svg";